import { useState } from "react";
import { Grid } from "@material-ui/core";
import CategorySelection from "./CategorySelection";
import IsuzuFilterOptions from "./IsuzuFilterOptions";

export default function IsuzuMarketplaceExporter() {
    const [selectedCategories, setSelectedCategories] = useState([]);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
                <CategorySelection
                    selectedCategories={selectedCategories}
                    setSelectedCategories={setSelectedCategories}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <IsuzuFilterOptions selectedCategories={selectedCategories} />
            </Grid>
        </Grid>
    );
}
